import './dialog.css'
import { getLocale } from './locale.js'

let root = null
let titleEl = null
let messageEl = null
let inputEl = null
let cancelBtn = null
let confirmBtn = null
let activeResolver = null
let escapeHandlerBound = false

function defaults() {
  return getLocale() === 'en'
    ? { confirm: 'Confirm', cancel: 'Cancel', promptTitle: 'Input Required', confirmTitle: 'Please Confirm' }
    : { confirm: '确定', cancel: '取消', promptTitle: '请输入', confirmTitle: '请确认' }
}

function ensureDialog() {
  if (root) return
  root = document.createElement('div')
  root.className = 'app-dialog'
  root.hidden = true
  root.innerHTML = `
    <div class="app-dialog-backdrop" data-role="backdrop"></div>
    <div class="app-dialog-panel" role="dialog" aria-modal="true" aria-labelledby="app-dialog-title">
      <h2 id="app-dialog-title" class="app-dialog-title"></h2>
      <p class="app-dialog-message"></p>
      <input class="app-dialog-input" hidden>
      <div class="app-dialog-actions">
        <button type="button" class="app-dialog-btn" data-role="cancel"></button>
        <button type="button" class="app-dialog-btn is-primary" data-role="confirm"></button>
      </div>
    </div>
  `
  document.body.appendChild(root)
  titleEl = root.querySelector('.app-dialog-title')
  messageEl = root.querySelector('.app-dialog-message')
  inputEl = root.querySelector('.app-dialog-input')
  cancelBtn = root.querySelector('[data-role="cancel"]')
  confirmBtn = root.querySelector('[data-role="confirm"]')
  root.querySelector('[data-role="backdrop"]')?.addEventListener('click', () => resolveDialog({ confirmed: false, value: null }))
  cancelBtn?.addEventListener('click', () => resolveDialog({ confirmed: false, value: null }))
  confirmBtn?.addEventListener('click', () => {
    resolveDialog({
      confirmed: true,
      value: inputEl?.hidden ? true : inputEl?.value ?? '',
    })
  })
  if (!escapeHandlerBound) {
    document.addEventListener('keydown', (event) => {
      if (!root || root.hidden) return
      if (event.key === 'Escape') {
        event.preventDefault()
        resolveDialog({ confirmed: false, value: null })
      } else if (event.key === 'Enter' && !event.shiftKey) {
        if (document.activeElement === inputEl || document.activeElement === confirmBtn) {
          event.preventDefault()
          resolveDialog({
            confirmed: true,
            value: inputEl?.hidden ? true : inputEl?.value ?? '',
          })
        }
      }
    })
    escapeHandlerBound = true
  }
}

function resolveDialog(result) {
  if (!root || root.hidden) return
  root.hidden = true
  const resolver = activeResolver
  activeResolver = null
  if (resolver) resolver(result)
}

function showBase({ title, message, confirmText, cancelText, input = false, defaultValue = '' }) {
  ensureDialog()
  const text = defaults()
  titleEl.textContent = title
  messageEl.textContent = message || ''
  confirmBtn.textContent = confirmText || text.confirm
  cancelBtn.textContent = cancelText || text.cancel
  inputEl.hidden = !input
  inputEl.value = defaultValue || ''
  root.hidden = false
  window.setTimeout(() => {
    if (input) inputEl.focus()
    else confirmBtn.focus()
  }, 0)
  return new Promise((resolve) => {
    activeResolver = resolve
  })
}

export async function showConfirmDialog(message, options = {}) {
  const text = defaults()
  const result = await showBase({
    title: options.title || text.confirmTitle,
    message,
    confirmText: options.confirmText,
    cancelText: options.cancelText,
  })
  return Boolean(result.confirmed)
}

export async function showPromptDialog(message, options = {}) {
  const text = defaults()
  const result = await showBase({
    title: options.title || text.promptTitle,
    message,
    confirmText: options.confirmText,
    cancelText: options.cancelText,
    input: true,
    defaultValue: options.defaultValue || '',
  })
  if (!result.confirmed) return null
  return typeof result.value === 'string' ? result.value : ''
}
